"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordCode = void 0;
const english_1 = require("./dicts/english");
const spanish_1 = require("./dicts/spanish");
class WordCode {
    constructor(dictName, words, normalizer) {
        this.dictName = dictName;
        this.words = words;
        this.bitsPerWord = Math.log2(this.words.length);
        this.normalizer = normalizer === undefined ? (x) => x.toLowerCase() : normalizer;
    }
    fillWordPositions() {
        if (this.wordPositions === undefined) {
            this.wordPositions = new Map();
            let pos = 0;
            for (const word of this.words) {
                this.wordPositions.set(this.normalizer(word), pos);
                pos = pos + 1;
            }
        }
    }
    // encode: get a hex string (containing a multiple of bitsPerWord bits), 
    // and get a sequence of words encoding it
    encode(hex) {
        const nibblesPerWord = this.bitsPerWord / 4;
        let wordNibbles = '';
        let words = [];
        for (let i = 0; i < hex.length; i++) {
            wordNibbles = wordNibbles + hex[i];
            if (wordNibbles.length === nibblesPerWord) {
                words.push(this.encodeWord(wordNibbles));
                wordNibbles = '';
            }
        }
        if (wordNibbles.length !== 0) {
            throw new Error('Trying to word-encode a hex string whose lenght does not correspond to a multiple of the bits-per-word constant.');
        }
        return words;
    }
    encodeWord(hex) {
        const pos = Number.parseInt(hex, 16);
        if (pos >= this.words.length) {
            throw new Error('Number is too large to encode as a single word');
        }
        return this.words[pos];
    }
    // decode: get a sequence of words, return the hex value they encode.
    decode(words) {
        var _a;
        this.fillWordPositions();
        let result = '';
        const nibblesPerWord = this.bitsPerWord / 4;
        for (let word of words) {
            let position = (_a = this.wordPositions) === null || _a === void 0 ? void 0 : _a.get(this.normalizer(word));
            if (position === undefined) {
                throw new Error('Trying to decode wordcoded number but received a word that is not in the dictionary "' + this.dictName + '":' + word);
            }
            result = result + position.toString(16).padStart(nibblesPerWord, '0');
        }
        return result.toUpperCase();
    }
}
exports.WordCode = WordCode;
WordCode.english = new WordCode(english_1.dictName, english_1.words);
WordCode.spanish = new WordCode(spanish_1.dictName, spanish_1.words, spanish_1.normalizer);
WordCode.lang = new Map([['es', WordCode.spanish], ['en', WordCode.english]]);
WordCode.all = [WordCode.english, WordCode.spanish];
//# sourceMappingURL=WordCode.js.map